import { Box, Divider, Typography, Button, ButtonGroup } from '@mui/material';

import React, {  } from 'react';
import __t from "../../../lib/traduzioni";
import useBSSLogger from '../../../hooks/useBSSLogger';


const {logger} = useBSSLogger(); 

//NON UTILIZZATO L'ORDINAMENTO INFICIA L'USABILITÀ DEL COMPARATORE, L'UTENTE PERDE DI VISTA IL CAMPO IN CUI STA INSERENDO IL VALORE (es. assicurazione)
const OrdinaPrezzi = ({ndatiFiltrati, clauses, setClauses,}) => {

    return (
        <>
            {/* {ndatiFiltrati > 1 && (
                <>

                    <Box mb={1}>
                        <Typography  style={{textAlign: "right"}}>
                            {__t("mostraprima")}
                            {" "}
                            <ButtonGroup variant="contained" size="small" color="primary">
                                <Button 
                                    disabled={clauses.sort.field === "totalprice" && clauses.sort.dir === "asc"}
                                    onClick={e => setClauses({...clauses, sort: {field: "totalprice", dir: "asc"}})}>
                                        {__t("piueconomico")}
                                </Button>
                                <Button 
                                    disabled={clauses.sort.field === "deliverydate" && clauses.sort.dir === "asc"}
                                    onClick={e => setClauses({...clauses, sort: {field: "deliverydate", dir: "asc"}})}>
                                        {__t("piuveloce")}
                                </Button>
                            </ButtonGroup>
                            
                        </Typography>
                    </Box>

                    <Divider />
                </>
            )}         */}
        </>
    )
}

export default OrdinaPrezzi;